module.exports = __webpack_public_path__ + "fonts/trade-gothic-condensed-18.b8f61c9f.woff";